export default {"src":"/_next/static/media/close-icn.db1d4f6c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};